export default {
  "associationProfile": "Association profile",
  "reset": "Reset",
  "save": "Save",
  "basicInfo": "Basic info",
  "associationName": "Association name",
  "enterTheAssociationName": "Enter the association name",
  "shownWithTheOrganizationLogoAtThe": "Shown with the organization logo at the top left of the mini program home page.",
  "phone": "Phone",
  "enterAContactNumber": "Enter a contact number",
  "email": "Email",
  "enterAnEmailAddress": "Enter an email address",
  "contact": "Contact",
  "enterAContactName": "Enter a contact name",
  "address": "Address",
  "enterAddress": "Enter address",
  "organizationLogo": "Organization logo",
  "uploading": "Uploading…",
  "uploadImage": "Upload image",
  "remove": "Remove",
  "weChatAccountQRCode": "WeChat account QR code",
  "qRCodeDestinationURL": "QR code destination URL",
  "enterTheURLToOpenWhenThe": "Enter the URL to open when the WeChat QR code is tapped. Leave blank to disable navigation.",
  "aboutTheAssociation": "About the association",
  "enterAnIntroductionToTheAssociation": "Enter an introduction to the association",
  "charterAndHonors": "Charter and honors",
  "associationCharter": "Association charter",
  "enterTheAssociationCharter": "Enter the association charter",
  "honors": "Honors",
  "enterHonorsAndAwards": "Enter honors and awards",
  "membershipGuidelines": "Membership guidelines",
  "enterMembershipGuidelines": "Enter membership guidelines",
  "memberBenefits": "Member benefits",
  "enterBenefitsShownOnTheMembershipApplication": "Enter benefits shown on the membership application page for existing members.",
  "restoredTheLastSavedContent": "Restored the last saved content",
  "couldNotLoadData": "Could not load data",
  "associationProfileSaved": "Association profile saved",
  "couldNotSaveChanges": "Could not save changes",
  "uploadFailed": "Upload failed",
  "imageUploaded": "Image uploaded",
  "miniProgramSettings": "Mini-program settings",
  "saveSettings": "Save settings",
  "systemSettings": "System settings",
  "organizationType": "Organization type",
  "eGChamberOfCommerceAssociationSociety": "E.g. chamber of commerce, association, society",
  "theMiniProgramDisplaysTheCorrespondingOrganization": "The mini program displays the corresponding organization type.",
  "shareTitle": "Share title",
  "shareImage": "Share image",
  "launchImage": "Launch image",
  "shownFullScreenForAbout25": "Shown full screen for about 2.5 seconds when the mini program opens. GIF images are supported. Leave blank to go straight to the home page.",
  "themeColor": "Theme color",
  "textVerification": "Text verification",
  "on": "On",
  "off": "Off",
  "miniProgram": "Mini program",
  "miniProgramAppID": "Mini program AppID",
  "weChatMiniProgramAppID": "WeChat mini program AppID",
  "miniProgramAppSecret": "Mini program AppSecret",
  "enterTheWeChatMiniProgramAppSecretLeave": "Enter the WeChat mini program AppSecret. Leave blank to keep the saved secret.",
  "weChatAccount": "WeChat account",
  "weChatAccountName": "WeChat account name",
  "enterTheWeChatAccountNameUsedAs": "Enter the WeChat account name used as the publisher of imported articles",
  "usedAsThePublisherNameWhenImporting": "Used as the publisher name when importing WeChat articles.",
  "weChatAccountAppID": "WeChat account AppID",
  "weChatOfficialAccountAppID": "WeChat official account AppID",
  "theAppIDAndSecretAreUsedFor": "The AppID and secret are used for WeChat account API access. Importing articles by URL only requires the account name.",
  "weChatAccountAppSecret": "WeChat account AppSecret",
  "leaveBlankToKeepTheSavedSecret": "Leave blank to keep the saved secret.",
  "agreements": "Agreements",
  "userAgreement": "User agreement",
  "enterTheUserAgreement": "Enter the user agreement",
  "privacyPolicy": "Privacy policy",
  "enterThePrivacyPolicy": "Enter the privacy policy",
  "paymentSettings": "Payment settings",
  "merchantID": "Merchant ID",
  "weChatPayMerchantID": "WeChat Pay merchant ID",
  "aPIV3Key": "API v3 key",
  "weChatPayPublicKeyID": "WeChat Pay public key ID",
  "pUBKEYIDLeaveBlankWhenUsing": "PUB_KEY_ID_…; leave blank when using a platform certificate",
  "weChatPayPublicKeyCertificate": "WeChat Pay public key / certificate",
  "uploadTheWeChatPayPublicKeyPEM": "Upload the WeChat Pay public key PEM and its public key ID, or a platform certificate whose serial number will be read automatically.",
  "paymentNotificationURL": "Payment notification URL",
  "usedAutomaticallyWhenCreatingPaymentOrdersIt": "Used automatically when creating payment orders. It must be publicly accessible over HTTPS. Link the merchant ID to this mini program AppID and enable mini program payments.",
  "subscriptionMessages": "Subscription messages",
  "membershipApproval": "Membership approval",
  "subscriptionMessageTemplateID": "Subscription message template ID",
  "templateKeywordsSourceApprovalTimeReminder": "Template keywords: Source, Approval time, Reminder",
  "membershipExpiryReminder": "Membership expiry reminder",
  "templateKeywordsMemberNameMembershipTypeExpiry": "Template keywords: Member name, Membership type, Expiry date, Notes",
  "registrationConfirmation": "Registration confirmation",
  "templateKeywordsEventNameAmountPaidVenue": "Template keywords: Event name, Amount paid, Venue, Event time, Contact number",
  "sMSSettings": "SMS settings",
  "sMSSignature": "SMS signature",
  "alibabaCloudSMSSignatureName": "Alibaba Cloud SMS signature name",
  "membershipApprovalSMS": "Membership approval SMS",
  "enterTheSMSTemplateCODE": "Enter the SMS template CODE",
  "templateDearWelcomeToXXXAssociationOur": "Template: Dear {token0}, welcome to XXX Association. Our secretariat is here to help. Sign in to the official XXX Association mini program to view and use your member benefits. Thank you for your support.",
  "upcomingFeeExpirySMS": "Upcoming fee expiry SMS",
  "templateDearThankYouForSupportingXXX": "Template: Dear {token0}, thank you for supporting XXX Association. Your membership fee expires on {token1}. Renew through our official mini program to continue receiving services. Contact the secretariat with any questions.",
  "membershipExpirySMS": "Membership expiry SMS",
  "templateDearYourMembershipAtXXXAssociation": "Template: Dear {token0}, your {token1} membership at XXX Association has expired. Renew your membership fee through our official mini program to continue enjoying member benefits. Thank you for your cooperation.",
  "newMembershipApplicationSMS": "New membership application SMS",
  "templateANewMembershipApplicationWasReceived": "Template: A new membership application was received. Name: {token0}; phone: {token1}. Review it in the mini program or management console.",
  "memberNotification": "Member notification",
  "templateDearYouHaveANewNotification": "Template: Dear {token0}, you have a new notification. View it in your personal center in the XXX Association mini program.",
  "notUploaded": "Not uploaded",
  "uploadAgain": "Upload again",
  "upload": "Upload",
  "configuredLeaveBlankToKeep": "Configured (leave blank to keep)",
  "enterAValue": "Enter a value",
  "failedToLoadSettings": "Failed to load settings",
  "miniProgramSettingsSaved": "Mini program settings saved",
  "noImageURLReturned": "No image URL returned",
  "couldNotUploadImage": "Could not upload image",
  "certificateUploadedToLocalStorage": "Certificate uploaded to local storage",
  "couldNotUploadCertificate": "Could not upload certificate",
  "uploadedFile": "Uploaded: {name}",
  "localCertificate": "Local certificate",
  "missingUploadObjectKey": "Upload failed: no object_key returned"
}
